function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 11H21",
  stroke: "#0A648F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 5H21",
  stroke: "#0A648F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 17H21",
  stroke: "#0A648F",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgMenu = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.0cd90ad2.svg";
export { ForwardRef as ReactComponent };